import React from 'react';
import classnames from 'classnames';
import styles from './content.module.css';

type ContentProps = {
  children: React.ReactNode;
  className?: string;
};

export const Content = ({ children, className }: ContentProps) => (
  <div className={classnames(styles.content, className)}>{children}</div>
);
